import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  removeStaffAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/staff/privilege/remove",
      payload
    ).then((response) => response);
  },
};

export default {
  actions,
};
